import React from 'react';

const formatDate = (date) => {
  if (!date) return '-';
  const d = new Date(date);
  return d.toLocaleDateString('ru-RU') + ' ' + d.toLocaleTimeString('ru-RU', {hour: '2-digit', minute: '2-digit'});
};

const Stats = ({ faqs }) => {
  const totalFAQs = faqs.length;
  
  const lastUpdated = faqs.reduce((latest, faq) => {
    const faqDate = new Date(faq.updated_at || faq.created_at);
    return faqDate > latest ? faqDate : latest;
  }, new Date(0));

  return (
    <div className="stats">
      <div className="stat-card">
        <div className="stat-number">{totalFAQs}</div>
        <div className="stat-label">Всего FAQ</div>
      </div>
      <div className="stat-card">
        <div className="stat-number">{formatDate(lastUpdated)}</div>
        <div className="stat-label">Последнее обновление</div>
      </div>
    </div>
  );
};

export default Stats; 